import { Component, EventEmitter, Input, Output, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BusinessModeService } from '../../_services/business-mode.service';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true
    }
  ]
})
export class RadioGroupComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() name: string = '';
  @Input() options: any[] = [];
  @Input() displayKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Input() currentLanguage: string = 'ru';

  @Output() selectChange = new EventEmitter<any>();

  private _value: any = null;

  constructor(public businessModeService: BusinessModeService, private cdRef: ChangeDetectorRef) {
  }

  // Светлая тема — обычная карточка-инпут; бизнес-тема (isBusiness=true, моб.) — карточка-список как в остальных бизнес-страницах
  get isBusinessMobile(): boolean {
    return this.businessModeService.isBusinessMobile;
  }

  @Input()
  set value(val: any) {
    if (val !== this._value) {
      this._value = val;
      this.onChange(val);
    }
  }

  get value(): any {
    return this._value;
  }

  private onChange: (value: any) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  getOptionDisplayText(option: any): string {
    const display = option[this.displayKey];
    return typeof display === 'object' ? display[this.currentLanguage] : display;
  }

  isSelected(option: any): boolean {
    return option[this.valueKey] === this.value;
  }

  selectOption(option: any): void {
    if (this.disabled) {
      return;
    }
    this._value = option[this.valueKey];
    this.onChange(this._value);
    this.onTouched();
    this.selectChange.emit(this._value);
    this.cdRef.detectChanges();
  }

  trackByOption = (index: number, option: any): any => option[this.valueKey];

  writeValue(value: any): void {
    if (value !== this._value) {
      this._value = value ?? null;
      this.cdRef.detectChanges();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
